import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'longmoon-star',
  templateUrl: './star.component.html',
  styleUrls: ['./star.component.scss']
})
export class StarComponent implements OnInit {
  @Input() xPos: number;
  @Input() yPos: number;
  @Input() period: number;
  @Input() color: string;
  @Input() size: string;

  constructor() {
  }

  ngOnInit(): void {
  }

}
